import { render, staticRenderFns } from "./DashboardHandler.vue?vue&type=template&id=7f7f618c&scoped=true"
import script from "./DashboardHandler.vue?vue&type=script&lang=js"
export * from "./DashboardHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7f618c",
  null
  
)

export default component.exports